export const purchaseUrl =
  'https://combo-completo-powerlifting-pro-2026.impultienda.ar/checkout'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/vHBuvqirPg7s3b6mgjjF7z/ChatGPT_Image_10_sept_2026,_07_41_49_p.m..png'

export const heroStats = [
  ['+150', 'entrenadores confían'],
  ['6', 'Tomos listos'],
  ['6', 'Bonos incluidos'],
  ['4,9/5', 'calificación ⭐'],
] as const

export const testimonials = [
  {
    initials: 'JC',
    name: 'Juan C.',
    place: 'Buenos Aires · Entrenador Certificado',
    text: 'Programé 52 semanas en una tarde. Mi atleta fue de 380 kg a 450 kg de total en 12 meses sin lesiones.',
  },
  {
    initials: 'MP',
    name: 'Martín P.',
    place: 'Córdoba · Studio Strength',
    text: 'Los protocolos post-lesión me permitieron traer de vuelta a un competidor que creíamos perdido. Ahora compite nuevamente.',
  },
  {
    initials: 'SG',
    name: 'Sofía G.',
    place: 'Mendoza · Preparadora Física',
    text: 'Finalmente tengo 100 ejercicios catalogados por punto débil. No más improvisación. Cada sesión tiene propósito.',
  },
]

export const developedTestimonials = [
  {
    initials: 'JC',
    name: 'Juan C.',
    place: 'Buenos Aires · 35 años · Entrenador Certificado',
    result: 'De 3 a 8 atletas compitiendo',
    text: 'Pasaba los fines de semana armando programas que después no funcionaban. Con los Tomos 1 a 5 diseñé una periodización clara y en 6 meses pasé de 3 a 8 atletas compitiendo. Mis clientes ven que PROGRESAN y eso es lo que los hace quedarse.',
  },
  {
    initials: 'MR',
    name: 'Matías R.',
    place: 'Córdoba · 42 años · Dueño de gimnasio',
    result: 'Retención del 60% al 94%',
    text: 'Mi problema eran los grupos mixtos: adolescentes y master en el mismo horario. Con el Tomo 6 cada atleta tiene su versión del programa, con su RPE y su descarga. La retención pasó de 60% a 94% y hoy mis propios alumnos recomiendan las clases.',
  },
  {
    initials: 'SG',
    name: 'Sofía G.',
    place: 'Mendoza · 38 años · Preparadora física Master',
    result: '6 meses sin lesiones en grupo Master',
    text: 'Le tenía miedo a entrenar Master por el riesgo. Con el protocolo del Tomo 6 abrí un grupo de 70+: 14 atletas, 6 meses, cero lesiones. Es el grupo más estable que tengo y el que más me recomienda.',
  },
  {
    initials: 'LB',
    name: 'Lucas B.',
    place: 'Rosario · 27 años · Entrenador de fuerza',
    result: 'Agenda llena en 4 meses',
    text: 'Salí de la carrera sabiendo teoría pero sin saber armar un ciclo real. El Tomo 1 me dio la evaluación y el Tomo 5 las semanas resueltas día a día. En cuatro meses llené la agenda sin gastar un peso en publicidad, solo usando los micros del Bono 3.',
  },
  {
    initials: 'VA',
    name: 'Valeria A.',
    place: 'Mar del Plata · 31 años · Coach de powerlifting femenino',
    result: '+22 kg de total promedio por atleta',
    text: 'Entreno solo mujeres y siempre adaptaba a ojo. Con la programación por ciclo hormonal del Tomo 6 y las variantes por punto débil del Bono 1, mis atletas subieron 22 kg de total promedio en un bloque de 16 semanas. Tres clasificaron al nacional.',
  },
]

export const modules = [
  {
    icon: '📋',
    name: 'Tomo 1 — Evaluación del atleta',
    period: 'Semanas 1-2 · Diagnóstico completo',
    content: [
      'Ficha maestra: perfil, punto débil, disponibilidad',
      '5 perfiles: Principiante, Intermedio I, Intermedio Avanzado, Avanzado y Élite',
      'Protocolos de evaluación: e1RM, RPE y recuperación',
      'Checklist de decisión: qué programa elegir',
    ],
  },
  {
    icon: '🦵',
    name: 'Tomo 2 — Técnica de sentadilla',
    period: 'Del patrón básico al máximo',
    content: [
      '30 variantes: Estándar, Front, Sumo, Paused, Tempo, Box y Déficit',
      'Organizado por problema: salida débil, cadena posterior, posición y velocidad',
      'Ejercicios complementarios: RDL, Hip Thrust, Leg Press y extensiones',
      '40 páginas de técnica pura, progresión y regresión',
    ],
  },
  {
    icon: '🏋️',
    name: 'Tomo 3 — Técnica de press de banca',
    period: 'De pecho débil a bloqueo perfecto',
    content: [
      '30 variantes: Estándar, Paused, Spoto, Pin Press, Incline, Close Grip y Dumbbell',
      'Organizado por fallo: pecho, midrange, bloqueo y trayectoria',
      'Ejercicios de apoyo: remo, dips, face pulls y extensiones de tríceps',
      'Protocolos de frecuencia: 1x, 2x y 3x por semana',
    ],
  },
  {
    icon: '💪',
    name: 'Tomo 4 — Técnica de peso muerto',
    period: 'Despegue, transición y bloqueo domados',
    content: [
      '20 variantes: Convencional, Sumo, Trap Bar, Block Pulls, Déficit y RDL',
      'Organizado por fase: despegue, rodillas, bloqueo y agarre',
      'Complementarios específicos: buenos días, farmer carries e isométricos',
      'Protocolos para ambas variantes: convencional vs sumo',
    ],
  },
  {
    icon: '📆',
    name: 'Tomo 5 — Programación 52 semanas',
    period: 'El año completo de periodización',
    content: [
      'Sistema anual: Evaluación → Construcción → Intensidad → Peaking',
      '3 rutas: Principiante (12 sem), Intermedio (16 sem) y Avanzado (20 sem)',
      'Semanas resueltas: día a día, serie por serie, RPE y carga',
      'Descarga cada 4 semanas (o 3 si es necesario)',
      'Master / 65+: protocolo especial cada 3 semanas',
    ],
  },
  {
    icon: '🏥',
    name: 'Tomo 6 — Perfiles especiales y regreso post-lesión',
    period: 'Jóvenes, Master, mujeres y post-lesión',
    content: [
      'Atletas jóvenes (menores de 20): RPE 8.5 máximo y énfasis en técnica',
      'Atletas Master (40+): descarga cada 3 semanas y movilidad aumentada',
      'Atletas femeninas: adaptación por ciclo hormonal',
      'Post-lesión: semáforo Verde / Amarillo / Rojo por articulación',
      'Regreso progresivo: hombro, codo, rodilla, espalda, cadera y muñeca',
    ],
  },
]

export const bonuses = [
  {
    number: '01',
    icon: '🎁',
    name: '100 ejercicios para puntos débiles',
    value: '$14.000',
    description:
      'Biblioteca práctica con más de 100 ejercicios y variantes para sentadilla, press de banca y peso muerto.',
    items: [
      'Incluye series, repeticiones, RPE y descansos',
      'Opciones según el punto débil de cada atleta',
      'Sentadilla débil: 30+ ejercicios',
      'Banca débil: 30+ ejercicios',
      'Peso muerto débil: 20+ ejercicios',
      'Formato rápido, práctico y listo para usar',
    ],
  },
  {
    number: '02',
    icon: '📚',
    name: 'Generador de programaciones',
    value: '$10.000',
    description: 'Sistema paso a paso para crear entrenamientos personalizados.',
    items: [
      'Definí nivel, frecuencia, objetivo y rendimiento del atleta',
      'Combiná ejercicios, cargas, volumen y progresiones',
      'Organizado y sistemático',
      'Ejemplos completamente resueltos',
      'Templates listos para copiar y pegar',
      'Decisiones tácticas según contexto',
    ],
  },
  {
    number: '03',
    icon: '🧮',
    name: 'Calculadoras y herramientas del coach',
    value: '$12.000',
    description: 'Tablas y fichas listas para la gestión diaria.',
    items: [
      'Calculadora de 1RM y e1RM',
      'Fichas de RPE / RIR',
      'Tablas de porcentajes y cargas',
      'Registro de marcas y evolución',
      'Seguimiento individual de cada atleta',
      'Herramientas prácticas para llevar datos',
    ],
  },
  {
    number: '04',
    icon: '💪',
    name: 'Casos prácticos de atletas',
    value: '$10.000',
    description: 'Más de 30 casos con atletas reales.',
    items: [
      'Diferentes niveles: principiante, intermedio y avanzado',
      'Diferentes edades: jóvenes, adultos y Master',
      'Diferentes pesos y necesidades',
      'Ejemplos de programación completa',
      'Ejercicios específicos por caso',
      'Modificaciones y soluciones reales',
    ],
  },
  {
    number: '05',
    icon: '🔥',
    name: 'Calentamientos y aproximaciones',
    value: '$10.000',
    description: 'Protocolos listos para preparar cada movimiento.',
    items: [
      'Calentamientos completos para sentadilla',
      'Calentamientos completos para banca',
      'Calentamientos completos para peso muerto',
      'Movilidad y activación específicas',
      'Series de aproximación listas',
      'Adaptados al tipo de sesión y atleta',
    ],
  },
  {
    number: '06',
    icon: '⚙️',
    name: 'Sistema anti-estancamiento',
    value: '$10.000',
    description: 'Detectá y resolvé qué modificar cuando no hay progresión.',
    items: [
      'Árboles de decisión claros',
      'Ajustes de volumen, intensidad y frecuencia',
      'Cambio estratégico de ejercicios',
      'Optimización de la recuperación',
      'Cómo volver a orientar la progresión',
      'Protocolos paso a paso para cada situación',
    ],
  },
] as const

export const pains = [
  'Programas que “más o menos funcionan” porque les falta estructura.',
  'Siempre los mismos ejercicios: no tenés un sistema de progresión claro.',
  'Atletas de distintos niveles sin planes diferenciados.',
  'Alumnos que hacen plateau a los 3 meses y no saben por qué.',
  'Horas perdidas en YouTube buscando variantes cuando necesitás la respuesta YA.',
  'La frustración de un atleta que no progresa pese a entrenar durísimo.',
]

export const included = [
  '6 Tomos completos: Evaluación, Sentadilla, Banca, Peso Muerto, Programación 52 semanas y Perfiles Especiales',
  'BONO 1 — 100 Ejercicios para Puntos Débiles (gratis)',
  'BONO 2 — Generador de Programaciones (gratis)',
  'BONO 3 — Calculadoras y Herramientas del Coach (gratis)',
  'BONO 4 — Casos Prácticos de Atletas (gratis)',
  'BONO 5 — Calentamientos y Aproximaciones (gratis)',
  'BONO 6 — Sistema Anti-Estancamiento (gratis)',
  'Garantía de 7 días sin preguntas',
]

export const faqs = [
  [
    '¿Sirve para todos los niveles?',
    'Sí. Son 6 tomos progresivos: Evaluación, Sentadilla, Banca, Peso Muerto, Programación 52 Semanas y Perfiles Especiales. Elegís dónde empezar según tu atleta, desde principiante completo hasta élite buscando el nacional.',
  ],
  [
    '¿Cómo recibo el material?',
    'Por email en menos de 5 minutos después de pagar. Son PDF descargables: 6 tomos + 6 bonos. Acceso de por vida, los bajás al celular o la computadora y podés imprimirlos.',
  ],
  [
    '¿Tiene garantía real?',
    'Sí, 7 días sin preguntas. Escribís a compradigitalyaa@gmail.com y te devolvemos el 100%, sin formularios ni justificaciones. La tasa de devoluciones es menor al 0,5%.',
  ],
  [
    '¿Necesito certificación previa para usar esto?',
    'No. Funciona igual si recién empezás a entrenar gente o si llevás 10 años con atletas competitivos. El sistema es escalable y cada tomo indica desde qué nivel aplicarlo.',
  ],
  [
    '¿Sirve para atletas Master o con limitaciones?',
    'Sí. El Tomo 6 tiene protocolos específicos para Master (40+), post-lesión, atletas femeninas y jóvenes. Cada población tiene su camino claro, con descargas y topes de RPE propios.',
  ],
  [
    '¿Cómo puedo pagar?',
    'En pesos argentinos con Mercado Pago, tarjeta de crédito o débito y transferencia bancaria, con cuotas según tu banco. Pago 100% seguro y datos encriptados.',
  ],
  [
    '¿Tendré acceso a actualizaciones futuras?',
    'Sí. Comprás una sola vez y tenés acceso de por vida. Si sacamos actualizaciones de los tomos o los bonos, las recibís sin costo adicional en el mismo correo.',
  ],
  [
    '¿Me sirve si entreno online y no tengo gimnasio propio?',
    'Sí. Las programaciones están pensadas para entregarse a distancia: semanas resueltas, RPE, carga y videos de referencia. El Bono 2 te arma el bloque completo listo para enviar por planilla o app.',
  ],
  [
    '¿Incluye la parte de programación semana a semana?',
    'Sí, el Tomo 5 está dedicado íntegramente a eso: 52 semanas de periodización con 3 rutas (12, 16 y 20 semanas), día a día, serie por serie, con descargas programadas y fases de peaking.',
  ],
  [
    '¿Puedo usarlo para capacitar a mi equipo de entrenadores?',
    'Sí, podés usarlo internamente para estandarizar la metodología de tu gimnasio o estudio. Lo que no está permitido es revenderlo o redistribuirlo fuera de tu equipo.',
  ],
] as const

export const recentPurchases = [
  ['Nicolás Ferreyra', 'Rosario, Santa Fe'],
  ['Julián Ibáñez', 'Córdoba Capital, Córdoba'],
  ['Rocío Maidana', 'La Plata, Buenos Aires'],
  ['Agustín Rojas', 'Godoy Cruz, Mendoza'],
  ['Belén Sosa', 'Mar del Plata, Buenos Aires'],
  ['Damián Quiroga', 'San Miguel de Tucumán, Tucumán'],
  ['Lucía Benítez', 'Neuquén Capital, Neuquén'],
  ['Nahuel Ojeda', 'Salta Capital, Salta'],
  ['Florencia Alsina', 'Bahía Blanca, Buenos Aires'],
  ['Emiliano Duarte', 'Posadas, Misiones'],
] as const
